import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import adrPlugin from '@backstage-community/plugin-adr/alpha';
import homePlugin from '@backstage/plugin-home/alpha';
import announcementsPlugin from '@backstage-community/plugin-announcements/alpha';
import entityFeedbackPlugin from '@backstage-community/plugin-entity-feedback/alpha';
import githubInsightsPlugin from '@roadiehq/backstage-plugin-github-insights/alpha';
import githubPullRequestsPlugin from '@roadiehq/backstage-plugin-github-pull-requests/alpha';
import pagerDutyPlugin from '@pagerduty/backstage-plugin/alpha';
import rbacPlugin from '@backstage-community/plugin-rbac/alpha';
import { navModule } from './modules/nav';
import { layoutModule } from './modules/layout';
import { themeModule } from './modules/theme';
import { signInModule } from './modules/auth';
import {
  catalogCardsModule,
  catalogIndexModule,
  codeInsightsCardsModule,
  entityFeedbackCardsModule,
  entityHeaderModule,
  entityPresentationModule,
  githubPullRequestsModule,
  orgCardsModule,
  overviewLayoutModule,
  securityInsightsModule,
} from './modules/catalog';
import { unlinkedIdentityBannerModule } from './modules/identity';
import { homeModule } from './modules/home';
import { notificationsModule } from './modules/notifications';
import { feedbackModule } from './modules/feedback';
import { pagerDutyModule } from './modules/pagerduty';
import { adminModule } from './modules/admin';
import { incidentsModule } from './modules/incidents';
import { adrModule } from './modules/adr';
import { searchModule } from './modules/search';
import { slackChannelsModule } from './modules/slackChannels';
import { recommendedDocsModule } from './modules/recommendedDocs';
import { techdocsModule } from './modules/techdocs';
import { techdocsRelatedArticlesAddonModule } from '@hone/plugin-techdocs-addon-related-articles';
import { userSettingsModule, userSettingsGeneralModule } from './modules/userSettings';

export default createApp({
  features: [
    catalogPlugin,
    homePlugin,
    announcementsPlugin,
    entityFeedbackPlugin,
    navModule,
    layoutModule,
    themeModule,
    signInModule,
    adrPlugin,
    adrModule,
    githubInsightsPlugin,
    githubPullRequestsPlugin,
    pagerDutyPlugin,
    pagerDutyModule,
    rbacPlugin,
    entityPresentationModule,
    catalogCardsModule,
    catalogIndexModule,
    codeInsightsCardsModule,
    entityFeedbackCardsModule,
    entityHeaderModule,
    orgCardsModule,
    githubPullRequestsModule,
    securityInsightsModule,
    overviewLayoutModule,
    unlinkedIdentityBannerModule,
    homeModule,
    notificationsModule,
    feedbackModule,
    adminModule,
    incidentsModule,
    searchModule,
    slackChannelsModule,
    recommendedDocsModule,
    userSettingsModule,
    userSettingsGeneralModule,
    techdocsModule,
    techdocsRelatedArticlesAddonModule,
  ],
});
